import { Button, ComboBox, TextInput } from '@abb/common-ux';
import { IUserToken } from '@module/authentication/models';
import { ICountry } from '@module/shared';
import { FetchCountries } from '@service/CountryService';
import { FetchPartsSpecialists } from '@service/RequestFilterLogService';
import * as React from 'react';

export default class RequestLogFilter extends React.Component<RequestLogFilterProps, IRequestLogFilterState> {

    constructor(props: RequestLogFilterProps) {
      super(props);
  
      this.state = {
        requestId: props.filter && props.filter.requestID || '',
        companyName: props.filter && props.filter.companyName || '', 
        partsSpecialistName: props.filter && props.filter.partsSpecialistName || '', 
        status: props.filter && props.filter.status || 'Pending', 
        countryId: props.filter && props.filter.countryId || '',
        countryName: props.filter && props.filter.countryName || '',
        listOfCountries: [],
        listOfPartsSpeclaists: []
      };
    }

    async componentDidMount() {
      this.setState({listOfPartsSpeclaists : await FetchPartsSpecialists(this.props.loggedInUser)});
      FetchCountries().then((countries: ICountry[]) => {
        this.setState({listOfCountries: countries});
      });
    }
  
    componentWillReceiveProps(nextProps: RequestLogFilterProps) {
      this.setState({
        requestId: nextProps.filter.requestID ? nextProps.filter.requestID : '',
        companyName: nextProps.filter.companyName ? nextProps.filter.companyName : '',
        partsSpecialistName: nextProps.filter.partsSpecialistName ? nextProps.filter.partsSpecialistName : '',
        status: nextProps.filter.status ? nextProps.filter.status : '',
        countryId: nextProps.filter.countryId ? nextProps.filter.countryId : '',
        countryName: nextProps.filter.countryName ? nextProps.filter.countryName : '',
      });
    }
  
    render() {

      const countriesOptions: any[] = [{
        label: '', value: ''
      }];
  
      this.state.listOfCountries.map((value: any) => {
        countriesOptions.push({ label: value.countryName, value: value.countryID });
      });

      const partsSpecialistOptions: any[] = [{
        label: '', value: ''
      }];
  
      this.state.listOfPartsSpeclaists.map((value: IPartsSpecialist) => {
        partsSpecialistOptions.push({ label: value.partsSpecialistName, value: value.partsSpecialistName });
      });

      return (
        <div className='panel panel-default'>
          <div className='panel-body'>
            <form id='ssFilterForm' onSubmit={this.handleSubmit}>
              <fieldset>
                <legend >Filter Requests</legend>
                <div className='row'>
                  <div className='col-lg-12'>
                    <TextInput name='requestId' id='requestId' inputSize='small'
                      labelText='Request ID' value={this.state.requestId} onChange={this.handleRequestIdChange} />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-12'>
                    <TextInput name='companyName' id='companyName' inputSize='small'
                      labelText='Company' value={this.state.companyName} onChange={this.handleCompanyNameChange} />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-12'>
                    <ComboBox
                        labelText='Parts Specialist'
                        options={partsSpecialistOptions}
                        value={this.state.partsSpecialistName}
                        onChange={this.handlePartsSpecialistChange} 
                        size='small'
                        searchable={false}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-12'>
                    <ComboBox
                        labelText='Status'
                        options={[{ label: '', value: '' }, { label: 'Pending', value: 'Pending' }, { label: 'Rejected', value: 'Rejected' }, { label: 'Approved', value: 'Approved' }]}
                        value={this.state.status}
                        onChange={this.handleStatusChange}
                        size='small'
                        searchable={false}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-12'>
                    <ComboBox
                        labelText='Country'
                        options={countriesOptions}
                        value={this.state.countryId}
                        onChange={this.handleCountryChange}
                        size='small'
                        searchable={true}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-6' />
                  <div className='col-lg-6  form-group text-right'>
                    <Button type='button' buttonType='normal' buttonSize='default' onClick={this.handleClear}>Clear</Button>{' '}
                    <Button type='submit' buttonType='primary' buttonSize='default'>Apply</Button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      );
    }
  
    handleRequestIdChange = (event: React.ChangeEvent<any>) => {
      this.setState({ requestId: event.target.value });
    }
  
    handleCompanyNameChange = (event: React.ChangeEvent<any>) => {
      this.setState({ companyName: event.target.value });
    }

    handlePartsSpecialistChange = (event: any) => {
      this.setState({ partsSpecialistName: event.value });
    }

    handleStatusChange = (event: any) => {
      this.setState({ status: event.value });
    }

    handleCountryChange = (event: any) => {
      this.setState({countryId: event.value, countryName: event.label});    
    }
  
    handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      this.props.onFilterApply(
        {
          requestID: this.state.requestId, 
          companyName: this.state.companyName, 
          partsSpecialistName: this.state.partsSpecialistName, 
          status: this.state.status, 
          countryId: this.state.countryId,
          countryName: this.state.countryName
        }
      );
    }
  
    handleClear = () => {
      this.props.onClear();
    }
  }
  
// tslint:disable-next-line:interface-name
interface RequestLogFilterProps {
    filter: RequestLogFilterValue;
    loggedInUser: IUserToken;
    onFilterValueChange: (value: string, key: string) => void;
    onFilterApply: (filter: RequestLogFilterValue) => void;
    onClear: () => void;
  }

interface IRequestLogFilterState {
    requestId: string;
    companyName: string;
    partsSpecialistName: string;
    status: string;
    countryId: string;
    countryName: string;
    listOfCountries: ICountry[];
    listOfPartsSpeclaists: IPartsSpecialist[];
  }

export interface IPartsSpecialist {
    partsSpecialistID: number;
    partsSpecialistName: string;
  }  
export class RequestLogFilterValue {
    requestID?: string;
    companyName?: string;
    partsSpecialistName?: string;
    status?: string;
    countryName?: string;
    countryId?: string;

    constructor(status: string = '') {
      this.requestID = '';
      this.companyName = '';
      this.partsSpecialistName = '';
      this.status = status;
      this.countryName = '';
      this.countryId = '';
    }
  }
  
function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser
  };
}
